import React from 'react';
import BBIconCheck from "../../assets/bbCustomIcons/BBIconCheck";
import {HashLink as Link} from "react-router-hash-link";
import {Button} from "@material-ui/core";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";

export const BizIntitialTourFree_Scores_NoOwnership = {
    url: `/board/BreachRisk/Business/Score`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        verified_ownership: false,
        subscription: "Business",
        subLevel: ["Free"],
        hasScores: true,
    },
    openingModal: {
        icon: null,
        heading: "Tour BreachRisk™ Score Page?",
        description: <div className={"text-center"}>
            <p>
                Welcome to BreachBits®!
            </p>
            <p>
                Your first BreachRisk&trade; score is available for you to view, but until you've verified ownership of your company's IT infrastructure, certain details won't be available to view.
            </p>
            <p>
                <BBExternalLink href={`https://support.breachbits.com/knowledge/why-and-how-to-verify-your-company-with-a-dns-record`} className={"text-white"}>
                    Learn more about how to do this and why we require it.
                </BBExternalLink> .
            </p>
            <p>
                Follow through with the tour on this page and throughout the application to get started learning about your new BreachRisk&trade; service.
            </p>

        </div>
    },
    tourSteps: {
        1:{
            step: 1,
            title: `Your BreachRisk™ Score`,
            content: <>
                <p>First things first, check your score. </p>
                <p>To learn more about how we determine your score, visit <Link smooth to={`/board/userguide`} className={"text-white"}><u>our Interactive User's Guide</u></Link>.</p>
            </>,
            scrollToElement: "#tourBRScoreDialRow",
            anchorEl: "#tourBRScoreDial",
            element: document.getElementsByClassName("tourBRScore"),
            last: false,
        },
        2: {
            step: 2,
            title: "Enable Penetration Testing",
            content: <>
                {/*<small><i> At least a pro level subscription is required for this service.</i></small>*/}
                <br/>
                <p>
                    We recommend enabling penetration testing to get the most out of your service.
                </p>
                <p>
                    This continuous perimeter testing requires you to have at least a Pro level subscription. You can upgrade your service on the <Link to={`/board/settings/subscription#manageSubscription`} className={"text-white"}><u> Manage Subscription </u></Link> page.
                </p>
            </>,
            anchorEl: "#tourBRHighFidelityTesting",
            element: document.getElementsByClassName("tourBRHighFidelityTesting"),
            last: false,
        },
        3: {
            step: 3,
            title: "Risk Benchmarks",
            content: `Risk Benchmarks allow you to compare your score to global averages. 
            Breach Risk and Breach Likelihood are key components in your score, 
            broken down here to see how the likelihood of a breach and the resulting impact compare to global averages. \n`,
            anchorEl: "#tourBRRiskBenchmarks",
            scrollToElement: "#tourBRHighFidelityTesting",
            element: document.getElementsByClassName("tourWidgetBenchmarks"),
            last: false,
        },
        4: {
            step: 4,
            title: "Score History",
            content: `See how your score has changed over time. \n`,
            anchorEl: "#tourBRScoreHistory",
            scrollToElement: "#tourScoreDial",
            element: document.getElementsByClassName("tourBRScoreHistoryWidget"),
            last: false,
        },
        5: {
            step: 5,
            title: "Attack Surface",
            content: <>
                <p>
                    Find the basic numbers about your company's attack surface— the viable IT elements and infrastructure and attacker sees and contemplates when planning or executing an attack.
                </p>
                <p>
                    Detailed information about what your attack surface looks like is available on the <Link smooth to={`/board/BreachRisk/Business/Report/TechData`} className={"text-white"}><u>Technical Details </u></Link>page.
                </p>
            </>,
            anchorEl: "#tourBRAttackSurfaceHeading",
            scrollToElement: "#tourBRScoreHistory",
            element: document.getElementsByClassName("#tourBRAttackSurfaceRow"),
            last: false,
        },
        6: {
            step: 6,
            title: "Attack Surface Benchmarks",
            content:<>
                <p>
                    Visualize how your IT elements and infrastructure compare to global averages using this chart.</p>
                <p>
                    You company is represented by the purple shape. Hover over types to find more details.
                </p>
            </> ,
            anchorEl: "#tourBRAttackSurfaceHeading",
            scrollToElement: "#tourBRAttackSurfaceBenchmarks",
            element: document.getElementsByClassName("tourBRAttackSurfaceBenchmarkWidget"),
            last: false,

        },
        7: {
            step: 7,
            title: "Risk Environment: Threat Vectors",
            content: <>
                <p>This provides you with a high level look at where your exploitable risks rank in terms of an attacker's ability to succeed and the resulting damage.</p>
                <p>You can find out more about these vectors starting in the <Link smooth to={`/board/BreachRisk/Business/Report/Overview`} className={"text-white"}><u> BreachRisk&trade; Report.</u></Link></p>
                <p>Detailed information about where these threats exist is available in <Link smooth to={`/board/BreachRisk/Business/Report/TechData`} className={"text-white"}><u> BreachRisk&trade; Technical.</u></Link>, which is available for Lite levels and higher.</p>
            </>,
            anchorEl: "#tourBRRiskCountCol",
            scrollToElement: "#tourBRRiskEnvironmentRow",
            element: document.getElementsByClassName("tourBRRiskEnvironmentWidgets"),
            last: false,

        },
        8: {
            step: 8,
            title: "Opportunities: Options For Attackers",
            content: <>
                <p>Attackers exploit different kind of weaknesses to breach a company's infrastructure.</p>
                <p>This is a high level look at what kind of risks your company's infrastructure has exposed. Find more about these individual threats in the
                    <Link smooth to={`/board/BreachRisk/Business/Report/Overview`} className={"text-white"}><u> BreachRisk&trade; Report.</u></Link>
                </p>
                <p>Detailed information about where these threats exist is available in <Link smooth to={`/board/BreachRisk/Business/Report/TechData`} className={"text-white"}><u> BreachRisk&trade; Technical.</u></Link>, which is available for Lite levels and higher.</p>
            </>,
            anchorEl: "#tourBRRiskOpportunitiesCol",
            scrollToElement: "#tourBRRiskEnvironmentRow",
            element: document.getElementsByClassName("tourBRRiskOpportunitiesWidgets"),
            last: false,

        },
        9: {
            step: 9,
            title: "Getting Started",
            content: "Make sure you're getting the most out of your BreachRisk™ subscription. This progress bar shows how much of the Getting Started Checklist you've completed.",
            anchorEl: "#progressBarMenuItem",
            element: null,
            last: false,
        },
        10: {
            step: 10,
            title: "Getting Started Checklist",
            content: "Visit Account Settings to find your Getting Started Checklist and see details about your progress.",
            anchorEl: "#tourStepAccountSettingsMenuItem",
            element: document.getElementsByClassName("tourStepAccountSettingsMenuItem"),
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "25px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}

